import { render } from "./SerraturaTypeBadge.vue?vue&type=template&id=04130d1c"
import script from "./SerraturaTypeBadge.vue?vue&type=script&lang=js"
export * from "./SerraturaTypeBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__